import {Component, ComponentRef, Input, ViewChild, ViewContainerRef} from '@angular/core';
import {BsModalRef, ModalOptions} from "ngx-bootstrap/modal";

export interface DialogButton {
    label: string;
    action: () => void;
    cssClass?: string;
    disabled?: () => boolean;
}

@Component({
    selector: 'app-std-dialog',
    exportAs: 'ngModel',
    templateUrl: './std-dialog.component.html',
    styleUrls: ['./std-dialog.component.scss']
})
export class StdDialogComponent {

    @Input()
    title: string

    @Input()
    execute: (component: any) => void;

    @Input()
    additionalButtons: DialogButton[] = [];

    @Input()
    showOk: boolean = true;

    @Input()
    showCancel: boolean = true;

    private _modalRef: BsModalRef;

    @ViewChild('container', { read: ViewContainerRef, static: true })
    container: ViewContainerRef;

    @Input()
    componentName: string;

    private componentRef: ComponentRef<{}>;

    constructor(public options: ModalOptions) {
    }

    public install(cmp:any, config?: any): ComponentRef<any> {
        this.componentRef = this.container.createComponent(cmp);
        if(config)
            (this.componentRef.instance as unknown as any).config = config;
        return this.componentRef;
    }

    get valid():boolean {
        if(!this.componentRef)
            return false;
        return (this.componentRef.instance as unknown as any).valid;
    }

    dismiss() {
        this._modalRef.hide();
        this.container.clear();
    }

    ok() {
        this.execute(this.componentRef.instance);
    }

    set modalRef(modalRef: BsModalRef) {
        this._modalRef = modalRef;
    }

    isButtonDisabled(button: DialogButton): boolean {
        return button.disabled ? button.disabled() : false;
    }

    onButtonClick(button: DialogButton) {
        button.action();
    }
}